import { createFormHook, formOptions } from "@tanstack/react-form";
import { fieldContext, formContext } from "./Form";
import {
    CommentSectionCheckbox,
    Input,
    MultipleChoiceInput,
    RequiredCheckbox,
    TextArea,
} from "./FormComponents";
import { Taxonomy } from "./Taxonomy";
import { QuestionType, type CreateQuestion } from "@pulse/api/surveyApi";

const { useAppForm: useEditSurveyForm, withForm } = createFormHook({
    fieldContext,
    formContext,
    fieldComponents: {
        Input,
        CommentSectionCheckbox,
        MultipleChoiceInput,
        TextArea,
        Taxonomy,
        RequiredCheckbox,
    },
    formComponents: {},
});

const formOpts = formOptions({
    defaultValues: {
        questionText: "",
        questionOptions: null,
        allowComments: false,
        questionType: QuestionType.RATING,
        questionOrder: 0,
        driverId: null,
        optional: false,
    } as CreateQuestion,
});

export { useEditSurveyForm, withForm, formOpts };
